import { Grid, Stack, Text, Title } from '@mantine/core';

import { TransitControlResult } from '@e-origin/shared';

interface ControlResultDetailsProps {
  controlResult: TransitControlResult;
}

export const ControlResultDetails = ({ controlResult: item }: ControlResultDetailsProps) => {
  return (
    <Stack key={`control-result`} mb="md">
      <Title order={5} fw={600}>
        Control result
      </Title>
      <Grid>
        <Grid.Col span={3}>
          <Stack gap="xs">
            <Text c="gray" size="sm">
              Date
            </Text>
            <Text fw={500}>{item.date}</Text>
          </Stack>
        </Grid.Col>
        <Grid.Col span={3}>
          <Stack gap="xs">
            <Text c="gray" size="sm">
              Control code
            </Text>
            <Text fw={500}>{item.code}</Text>
          </Stack>
        </Grid.Col>
      </Grid>
      <Grid>
        <Grid.Col span={3}>
          <Stack gap="xs">
            <Text c="gray" size="sm">
              Remarks
            </Text>
            <Text fw={500}>{item.remarks}</Text>
          </Stack>
        </Grid.Col>
      </Grid>
      <Grid>
        <Grid.Col span={3}>
          <Stack gap="xs">
            <Text c="gray" size="sm">
              Text
            </Text>
            <Text fw={500}>{item.text}</Text>
          </Stack>
        </Grid.Col>
      </Grid>
      <Grid>
        <Grid.Col span={3}>
          <Stack gap="xs">
            <Text c="gray" size="sm">
              Controlled by
            </Text>
            <Text fw={500}>{item.controlledBy}</Text>
          </Stack>
        </Grid.Col>
      </Grid>
    </Stack>
  );
};
